import React from "react";
import { FaSearch, FaCog, FaBell } from "react-icons/fa";


function StudentNavbar() {

     const user = {
        name: "Student",
        email: "student.m@example.com",
        image: "https://randomuser.me/api/portraits/men/1.jpg", 
      };
    
      const icons = [<FaCog key="settings" />, <FaBell key="notifications" /> ];
  return (
    <>
        <div className="navbarss">
            <div className="navbar-left">
              <span className="greeting">Hello {user.name} 👋</span>
            </div>
      
            <div className="search-bar">
              <FaSearch className="search-icon" />
              <input type="text" placeholder="Search..." />
            </div>
      
            <div className="navbar-right">
              {icons.map((icon, index) => (
                <span key={index} className="icon">
                  {icon}
                </span>
              ))}
      
              <div className="profile">
                <img src={user.image} alt="Profile" className="profile-img" />
                <div className="profile-info">
                  <span className="profile-name">{user.name}</span>
                  <span className="profile-email">{user.email}</span>
                </div>
              </div>
            </div>
          </div>
    </>
  )
}

export default StudentNavbar
